import api from '../api-methods'

const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API

const transferStation = {
  // 照片质量检测
  photoCheck: payload => {
    return api.post(proxyApi + `/v3/photo/cut_check_pic`, payload)
  },
  // 上传照片到电脑
  uploadPhoto: (marking, payload) => {
    return api.post(proxyApi + `/v3/file_upload?marking=${marking}`, payload)
  }
}

export default transferStation
